import React, { FC } from "react";
import { ReportPage, ReportTreasurySearchPanel } from "../../../components";
import { PageEnum, TreasuryReportSearchParamsModel } from "../../../models";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import { searchReportInMoney } from "../../../serviceBroker/treasuryReportApiServiceBroker";
import { subDays } from "date-fns";

export const ReportInMoneyPage: FC = () => {
  const today = new Date();
  const sevenDaysAgo = subDays(today, 7);

  const initialState: TreasuryReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
    toDate: new Date(),
    fromDate: sevenDaysAgo,
  };
  return (
    <ReportPage
      InitialState={initialState}
      excludeFields={["currencyId"]}
      SearchApi={searchReportInMoney}
      searchHeader={getPageNameByPageId(PageEnum.ReportInMoney)}
      SearchPanel={ReportTreasurySearchPanel}
      formId={PageEnum.ReportInMoney}
    />
  );
};
